<script>
import Page from '@/components/elements/Page';
import PageIntro from '@/components/elements/PageIntro';
import PageChoice from '@/components/elements/PageChoice';

export default {
    name: 'ChoiceProof',
    components: { Page, PageIntro, PageChoice },
    computed: {
        maxValidityHoursForTestResult() {
            return 48;
        }
    },
    methods: {
        back() {
            this.$router.push({ name: 'Home' })
        },
        gotoChoiceTestLocation() {
            this.$router.push({ name: 'CollectTestCW' });
        },
        gotoAanmeldingVaccination() {
            this.$router.push({ name: 'signupInformation' }).catch(() => { alert('Error ') });
        },
        gotoCollectRecovery() {
            this.$router.push({ name: 'CollectRecoveryCW' });
        },
        gotoCollectVaccination() {
            this.$router.push({ name: 'CollectVaccinationCW' });
        }
    },
    mounted() {
        if (this.$store.state.userConsent !== true) {
            this.$router.push({ name: 'Home' });
        };
    }
}
</script>

<template>
    <Page @back="back">
        <div class="section">
            <PageIntro
                :head="$t('views.choiceProof.pageHeader')"
                :intro="$t('views.choiceProof.pageIntro', { maxValidityHoursForTestResult: maxValidityHoursForTestResult })"/>
            <div class="section-block">
                <div class="page-choices">
                    <PageChoice
                        @select="gotoAanmeldingVaccination"
                        :header="$t('views.choiceProof.choiceAanmeldingHeader')"
                        :body="$t('views.choiceProof.choiceAanmeldingBody')"/>
                    <PageChoice
                        @select="gotoCollectVaccination"
                        :header="$t('views.choiceProof.choiceVaccinationHeader')"
                        :body="$t('views.choiceProof.choiceVaccinationBody')"/>
                    <PageChoice
                        @select="gotoChoiceTestLocation"
                        :header="$t('views.choiceProof.choiceTestHeader')"
                        :body="$t('views.choiceProof.choiceTestBody')"/>
                    <PageChoice style="margin-bottom: 200px;"
                        @select="gotoCollectRecovery"
                        :header="$t('views.choiceProof.choiceRecoveryHeader')"
                        :body="$t('views.choiceProof.choiceRecoveryBody')"/>
                </div>
            </div>
        </div>
    </Page>
</template>

<style lang="scss">

</style>
